import React, { useRef, useMemo } from "react";
import {
  Grid,
  Typography,
  Theme,
  makeStyles,
  createStyles,
} from "@material-ui/core";
import { IArticle } from "../../core/redux/dataMap/article";
import { useHistory } from "react-router-dom";
import JoditEditor from "jodit-react";
import { Creators as LabelsCreaters } from "../../core/redux/ducks/label";
import { useDispatch } from "react-redux";

interface IArticleEditorProps {
  article: IArticle;
  onHide(): void;
}

export const ArticleEditor: React.FC<IArticleEditorProps> = ({
  article,
  onHide,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleEditClick = () => {
    onHide();
    dispatch(LabelsCreaters.getLabelsSuccess(article.labels));
    history.push({
      pathname: "/search",
      state: { status: "open" },
    });
  };
  const editorRef = useRef(null);

  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        className={classes.header}
        justify="space-between"
      >
        <Grid item>
          <Typography variant="h2" className={classes.title}>
            {article.editor.title || article.name}
          </Typography>
        </Grid>
        <Grid item>
          <div onClick={handleEditClick} className={classes.editButton}>
            <Typography className={classes.editText}>Edit</Typography>
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item className={classes.editorLine}>
          <div className={classes.editorContainer}>
            <div className={classes.editorBody}>
              <JoditEditor
                ref={editorRef}
                value={article.editor.content}
                config={{
                  readonly: true,
                  toolbar: true,
                  //@ts-ignore
                  minHeight: "450px",
                }}
                tabIndex={1} // tabIndex of textarea
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "block",
      boxSizing: "border-box",
      width: "100%",
      boxShadow:
        "2px 0px 2px -5px rgba(0,0,0,0.2), 1px 4px 1px -1px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
      paddingRight: "25px",
      borderBottomRightRadius: "10px",
      borderTopRightRadius: "10px",
      marginRight: "8px",
      backgroundColor: "white",
    },
    header: {
      margin: "15px",
      alignItems: "center",
    },
    title: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "22px",
      lineHeight: "25px",
      color: "#323232",
    },
    editButton: {
      display: "flex",
      width: "100%",
      justifyContent: "flex-end",
      cursor: "pointer",
      padding: "10px",
      "&:hover": {
        backgroundColor: "whitesmoke",
        borderRadius: "6px",
        // boxShadow:
        //   "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
      },
    },
    editText: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "15px",
      letterSpacing: "0.4px",
    },
    editorLine: {
      width: "100%",
    },
    editorContainer: {
      flex: 1,
      width: "100%",
      padding: "0 30px",
      // boxShadow: "-1px 6px 6px -2px rgba(0, 0, 0, 0.1)",
      borderRadius: "6px",
    },
    editorBody: {
      padding: "0 50px",
      margin: "0 -50px",
      maxHeight: "800px",
      minHeight: "500px",
      overflow: "auto",
    },
  })
);
